import styled from 'styled-components'
import { Layout } from 'antd'
const { Content } = Layout

export const Headline = styled.div`
	text-align: center;
	margin-bottom: 30px;
`

export const Wrapper = styled.div`
	margin-top: 60px;
	margin-bottom: 54px;
`

export const StyledContent = styled(Content)`
	flex-direction: column;
	display: flex;
	max-width: 600px;
	margin: auto;
`
